export default __webpack_public_path__ + "static/media/Prologue_Kyo2US.5635c2ba.png";